import { TenantGeneralData } from './tenantGeneralData';

export class CommonGroup extends TenantGeneralData {
  name: string = null;
  id: any = null;
}

export class CommonGroupOrder {
  groupId: any = null;
  index: number = null;
}

export class CommonGeneralData extends TenantGeneralData {
  id: any = null;
  groups: CommonGroup[] = [];
  groupOrder: CommonGroupOrder[] = [];
  translationKey: string = null;
}

export class CommonMeasureUnit extends CommonGeneralData {
  value: string = null;
  name: string = null;
  symbol: string = null;
  type: string = null;
  conversionFactor: string = null;
  description: string = null;
  system: string = null;
  precision: string = null;
}

export class CommonCommodity extends CommonGeneralData {
  eppo: string = null;
  note: string = null;
  cropType: string = null;
}

export interface CommonPrecocity {
  id: string;
  name?: string;
  translationKey: string;
  externalResources: any[];
  groups: CommonGroup[];
  groupOrder: CommonGroupOrder[];
}

export interface CommonCommodityPrecocity {
  id: string;
  name?: string;
  commodityId: string;
  precocityId: string;
}

export class CommonVariety extends CommonGeneralData {
  eppo: string = null;
  note: string = null;
}

export class CommonQuality extends CommonGeneralData {
  eppo: string = null;
  note: string = null;
  name: string = null;
}

export class CommonUse extends CommonGeneralData {
  eppo: string = null;
  note: string = null;
  name: string = null;
}

export class CommonChemicalElement extends CommonGeneralData {
  elementId: string = null;
  name: string = null;
  periodicTableName: string = null;
  translationKey: string = null;
  value: any = null;
  unitsOfMeasure: any[] = [];
}

export class CommonSoilType extends CommonGeneralData {
  name: string = null;
}

export class CommonRegion extends CommonGeneralData {
  region: string = null;
  ISO_3166: string = null;
  'ISO_3166-2': string = null;
}

export class CommonCountry extends CommonGeneralData {
  id: any = null;
  name: string = null;
}

export class CommonIntendedUse extends CommonGeneralData {
  name: string = null;
}

export class CommonIntendedUseCommodityMapping extends CommonGeneralData {
  name: string = null;
  commodityId: any = null;
  intendedUseId: any = null;
}

export class CommonPhenoStage extends CommonGeneralData {
  name: string = null;
  parentId: string = null;
}

export class CommonStrategy extends CommonGeneralData {
  name: string = null;
}

export class CommonStrategyLink extends CommonGeneralData {
  name: string = null;
  commodityId: number = null;
  irrigationStrategyId: string = null;
}

export class CommonPhenoStagePerCommodity extends TenantGeneralData {
  name: string = null;
  commodityId: number = null;
  phenologicalPhaseId: string = null;
  startDate: string = null;
  endDate: string = null;
}

export const commonGroupNames = {
  ITALIAN_REGIONS: 'ITALIAN_REGIONS',
  SOIL_ANALYSIS: 'SOIL_ANALYSIS',
  SOIL_ANALYSIS_V2: 'SOIL_ANALYSIS_V2',
  CHECKS: 'CHECKS',
  NPK: 'NPK',
  ITALIAN_REGIONS_DISCIPLINARI: 'ITALIAN_REGIONS_DISCIPLINARI',
  NUTRITION_DASHBOARD_ELEMENT: 'NUTRITION_DASHBOARD_ELEMENT',
  NUTRITION_INSTANCE_ELEMENT: 'NUTRITION_INSTANCE_ELEMENT',
  NPK_MACRONUTRIENTS: 'NPK_MACRONUTRIENTS',
  NPK_MICRONUTRIENTS: 'NPK_MICRONUTRIENTS',
  NPK_ANALYSIS: 'NPK_ANALYSIS',
  SOIL_ANALYSIS_UK: 'SOIL_ANALYSIS_UK',
};
